enum Status {
    COMPLETE,
    INPROGRESS,
    INITIAL,
}

export enum DocumentSide {
    FRONT = 'FRONT',
    BACK = 'BACK',
}

export interface IDocumentDataState {
    progress: number;
    status: Status;
    isSubmitting: boolean;
    error: boolean;
}

interface IUserVerificationState {
    sides: Record<DocumentSide, IDocumentDataState>;
}

interface IVerificationCompleteAction {
    type: 'complete';
    payload: { side: DocumentSide };
}

interface IVerificationLoadingAction {
    type: 'loading';
    payload: {
        side: DocumentSide;
    };
}

interface IVerificationErrorAction {
    type: 'error';
    payload: {
        side: DocumentSide;
    };
}

interface IVerificationInProgressAction {
    type: 'progress';
    payload: {
        side: DocumentSide;
        progress: number;
    };
}

type VerificationAction =
    | IVerificationCompleteAction
    | IVerificationLoadingAction
    | IVerificationInProgressAction
    | IVerificationErrorAction
    | { type: 'reset' };

export function userVerificationReducer(
    state: IUserVerificationState,
    action: VerificationAction,
): IUserVerificationState {
    switch (action.type) {
        case 'reset':
            return USER_VERIFICATION_INITIAL_STATE;
        case 'complete':
            return {
                ...state,
                sides: {
                    ...state.sides,
                    [action.payload.side]: {
                        ...state.sides[action.payload.side],
                        progress: 100,
                        isSubmitting: false,
                        status: Status.COMPLETE,
                    },
                },
            };
        case 'progress':
            return {
                ...state,
                sides: {
                    ...state.sides,
                    [action.payload.side]: {
                        ...state.sides[action.payload.side],
                        progress: action.payload?.progress,
                    },
                },
            };
        case 'loading':
            return {
                ...state,
                sides: {
                    ...state.sides,
                    [action.payload.side]: {
                        ...state.sides[action.payload.side],
                        progress: 0,
                        isSubmitting: true,
                    },
                },
            };
        case 'error':
            return {
                ...state,
                sides: {
                    ...state.sides,
                    [action.payload.side]: {
                        ...state.sides[action.payload.side],
                        error: true,
                        isSubmitting: false,
                        progress: 0,
                    },
                },
            };
    }
}

export const USER_VERIFICATION_INITIAL_STATE: IUserVerificationState = {
    sides: {
        [DocumentSide.FRONT]: {
            progress: 0,
            status: Status.INITIAL,
            isSubmitting: false,
            error: false,
        },
        [DocumentSide.BACK]: {
            progress: 0,
            status: Status.INITIAL,
            isSubmitting: false,
            error: false,
        },
    },
};
